/* eslint-disable max-lines */
import { useContext } from 'react';
import {
  COLOR1,
  COLOR3,
  COLOR4,
  GRAY44,
  FONT_BOLD_16_18,
  ORIENTAL_D_GRAY,
  RADIO_COLOR,
  COLOR2,
} from '../../constants';
import LeadGenerationContext from '../../context/LeadGenerationContext';

export const CommonStyles = (theme) => ({
  ssnTooltip: {
    display: 'flex',
    alignSelf: 'center',
    justifyContent: 'center',
    '@media (between: 1190px, 1145px)': {
      marginLeft: '10px',
    },
  },
  customBorderRadius: {
    borderRadius: '30px !important',
    // border: '1px solid #E4E9F2',
  },
  noBorder: {
    border: 'none',
  },
  ssnTextTooltip: {
    marginLeft: '3px',
    color: '#661C69',
    textAlign: 'center',
    fontFamily: 'TTNormsProBold !important',
    fontSize: '10px',
    lineHeight: '12px',
  },
  snackBarMobile: {
    '@media (max-width: 450px)': {
      margin: '25px 0 50px 0',
    },
  },
  disabled_button: {
    '&.MuiButton-root.Mui-disabled': {
      background: `#F3F3F3`,
      border: `#F3F3F3`,
      borderRadius: '25px',
      color: '#A7A7A7',
      width: '165px',
      height: '45px',
      font: 'normal normal bold 16px/18px Arial',
      letterSpacing: '1.01px',
      textTransform: 'none',
      '&:hover': {
        backgroundColor: '#F3F3F3',
      },
      '@media (max-width: 600px)': {
        width: '100%',
      },
    },
  },
  input: {
    fontSize: '16px',
  },
  label_title: {
    marginBottom: '10px',
    lineHeight: '18px',
    letterSpacing: '0.1px',
    position: 'relative',
    textAlign: 'left',
  },
  adorned_end: {
    padding: 0,
  },
  notchedOutline: {
    border: 'none',
    borderRadius: '6px',
  },
  notchedOutlineErr: {
    border: `1px solid ${COLOR2}`,
    borderRadius: '6px',
  },
  outlined_input_bundle: {
    height: '48px',
    width: '100%',
    borderRadius: '6px',
    textAlign: 'left',
    backgroundColor: theme?.palette?.fieldsBackground?.main,
    border: `1px solid ${theme?.palette?.fieldsBorder?.main}`,
    color: theme?.palette?.primary?.main,

    // color: COLOR1,
    letterSpacing: '0.1px',
    opacity: 1,
    display: 'flex',
    gap: '12px',
    padding: '16px !important',

    '& .MuiOutlinedInput-input': {
      padding: '14px 14px 10px 14px',
    },
    '& ::-webkit-input-placeholder': {
      color: ORIENTAL_D_GRAY,
      opacity: 0.8,
    },
    '& ::-moz-placeholder': {
      color: ORIENTAL_D_GRAY,
      opacity: 0.8,
    },
    '& :-ms-input-placeholder': {
      color: ORIENTAL_D_GRAY,
      opacity: 0.8,
    },
    '@media (max-width: 600px)': {
      width: '100%',
      height: '48px',
      transform: 'rotate(0deg)',
      opacity: 1,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      '& ::-webkit-input-placeholder': {
        font: 'normal 400 16px Arial',
        color: '#808285',
      },
      '& ::-moz-placeholder': {
        font: 'normal 400 16px Arial',
        color: '#808285',
      },
      '& :-ms-input-placeholder': {
        font: 'normal 400 16px Arial',
        color: '#808285',
      },
    },
  },
  outlined_inputs: {
    height: '48px',
    background: '#FFFFFF',
    border: '1px solid #E2E2E2',
    borderRadius: '6px',
    textAlign: 'left',
    color: COLOR1,
    font: 'normal normal 400 16px/18px Arial',
    letterSpacing: '0.1px',
    opacity: 1,

    '& .MuiOutlinedInput-input': {
      padding: '11.5px 14px',
    },
    '& ::-webkit-input-placeholder': {
      color: ORIENTAL_D_GRAY,
      opacity: 0.8,
    },
    '& ::-moz-placeholder': {
      color: ORIENTAL_D_GRAY,
      opacity: 0.8,
    },
    '& :-ms-input-placeholder': {
      color: ORIENTAL_D_GRAY,
      opacity: 0.8,
    },
    '@media (max-width: 600px)': {
      '& ::-webkit-input-placeholder': {
        font: 'normal 400 16px Arial',
        color: '#808285',
      },
      '& ::-moz-placeholder': {
        font: 'normal 400 16px Arial',
        color: '#808285',
      },
      '& :-ms-input-placeholder': {
        font: 'normal 400 16px Arial',
        color: '#808285',
      },
    },
  },
  outlined_inputs_Mobile: {
    height: '48px',
    background: '#FFFFFF',
    border: '1px solid #E2E2E2',
    borderRadius: '6px',
    textAlign: 'left',
    color: COLOR1,
    font: 'normal normal 400 16px/18px Arial',
    letterSpacing: '0.1px',
    opacity: 1,
    '& ::-webkit-input-placeholder': {
      color: ORIENTAL_D_GRAY,
      opacity: 0.8,
    },
    '& ::-moz-placeholder': {
      color: ORIENTAL_D_GRAY,
      opacity: 0.8,
    },
    '& :-ms-input-placeholder': {
      color: ORIENTAL_D_GRAY,
      opacity: 0.8,
    },
    '@media (max-width: 600px)': {
      '& ::-webkit-input-placeholder': {
        font: 'normal 400 16px Arial',
        color: '#808285',
      },
      '& ::-moz-placeholder': {
        font: 'normal 400 16px Arial',
        color: '#808285',
      },
      '& :-ms-input-placeholder': {
        font: 'normal 400 16px Arial',
        color: '#808285',
      },
    },
  },

  outlined_inputs_disabled: {
    border: '1px solid #E4E9F2',
    background: '#F3F3F3',
  },
  outlined_inputs_empStatus: {
    height: '48px',
    background: '#EEEEEE',
    border: '1px solid #E4E9F2',
    borderRadius: '6px',
    textAlign: 'left',
    color: COLOR1,
    font: 'normal normal 400 16px/18px Arial',
    letterSpacing: '0.1px',
    opacity: 1,
    '& .MuiOutlinedInput-input': {
      padding: '11.5px 14px',
    },
    '&.MuiInputBase-root.Mui-disabled': {
      border: 'none',
    },
    '& ::-webkit-input-placeholder': {
      color: ORIENTAL_D_GRAY,
      opacity: 0.8,
    },
    '& ::-moz-placeholder': {
      color: ORIENTAL_D_GRAY,
      opacity: 0.8,
    },
    '& :-ms-input-placeholder': {
      color: ORIENTAL_D_GRAY,
      opacity: 0.8,
    },
    '@media (max-width: 600px)': {
      '& ::-webkit-input-placeholder': {
        font: 'normal 400 16px Arial',
        color: '#808285',
      },
      '& ::-moz-placeholder': {
        font: 'normal 400 16px Arial',
        color: '#808285',
      },
      '& :-ms-input-placeholder': {
        font: 'normal 400 16px Arial',
        color: '#808285',
      },
    },
  },
  saveButtonBox: {
    '@media (max-width: 1038px)': {
      marginBottom: '30px',
    },
  },
  marginTopGrid: {
    marginTop: '40px',
    '@media (max-width: 1038px)': {
      marginTop: '30px',
    },
  },
  button_grid: {
    flexWrap: 'nowrap',
    padding: '30px 0 20px 0',
    justifyContent: 'flex-end',
    textAlign: 'right',
    '@media (max-width: 1038px)': {
      flexWrap: 'wrap',
    },
    '@media (max-width: 600px)': {
      paddingTop: '30px',
      paddingBottom: '20px',
      justifyContent: 'center',
    },
  },
  back_button: {
    border: `1px solid ${RADIO_COLOR}`,
    borderRadius: '25px',
    opacity: 1,
    width: '165px',
    height: '45px',
    margin: '0px 15px 0px 0px',
    font: FONT_BOLD_16_18,
    // letterSpacing: '1.01px',
    color: `${RADIO_COLOR} !important`,
    textTransform: 'none',
    '&:hover': {
      backgroundColor: COLOR4,
    },
    '&:focus': {
      outline: `2px solid ${RADIO_COLOR}`,
      outlineOffset: '2px',
    },
    '@media (max-width: 600px)': {
      width: '100%',
    },
  },
  back_button_Consumer: {
    border: `1px solid ${RADIO_COLOR}`,
    borderRadius: '25px',
    opacity: 1,
    width: '213px',
    height: '48px',
    margin: '0px 15px 0px 0px',
    font: FONT_BOLD_16_18,
    // letterSpacing: '1.01px',
    color: `${RADIO_COLOR} !important`,
    textTransform: 'none',
    '&:hover': {
      backgroundColor: COLOR4,
    },
    '&:focus': {
      outline: `2px solid ${RADIO_COLOR}`,
      outlineOffset: '2px',
    },
    '@media (max-width: 600px)': {
      width: '100%',
    },
  },
  checkbox: {
    margin: '3px',
    '&:focus': {
      outline: `2px solid ${RADIO_COLOR}`,
      outlineOffset: '2px',
    },
  },
  continue_button: {
    border: `1px solid ${theme?.palette?.orientalPrimary?.main}`,
    background: `${theme?.palette?.orientalPrimary?.main} 0% 0% no-repeat padding-box`,
    borderRadius: '25px',
    opacity: 1,
    width: '165px',
    height: '45px',
    font: FONT_BOLD_16_18,
    textTransform: 'none',
    color: theme?.palette?.secondary?.main,
    '&:hover': {
      backgroundColor: theme?.palette?.orientalPrimary?.main,
    },
    '&:focus': {
      outline: `2px solid ${theme?.palette?.orientalPrimary?.main}`,
      outlineOffset: '2px',
    },
    '@media (max-width: 600px)': {
      width: '100%',
      // marginBottom: '20px',
    },
    '&.Mui-disabled span': {
      opacity: 0.6,
    },
  },
  save_continue_button: {
    border: `1px solid ${theme?.palette?.orientalPrimary?.main}`,
    background: `${theme?.palette?.orientalPrimary?.main} 0% 0% no-repeat padding-box`,
    color: theme?.palette?.secondary?.main,
    borderRadius: '25px',
    opacity: 1,
    height: '45px',
    font: FONT_BOLD_16_18,
    textTransform: 'none',
    letterSpacing: '1.01px',
    '&:hover': {
      backgroundColor: RADIO_COLOR,
    },
    '&:focus': {
      outline: `2px solid ${RADIO_COLOR}`,
      outlineOffset: '2px',
    },
    '@media (max-width: 600px)': {
      width: '100%',
      // marginBottom: '20px',
    },
    '&.Mui-disabled span': {
      opacity: 0.6,
    },
  },
  save_disabled_button: {
    '&.MuiButton-root.Mui-disabled': {
      background: `#E4E9F2`,
      border: `#E4E9F2`,
      borderRadius: '25px',
      color: 'rgba(143, 155, 179, 0.5)',
      width: '228px',
      height: '45px',
      font: 'normal normal bold 16px/18px Arial',
      letterSpacing: '1.01px',
      textTransform: 'none',
      '&:hover': {
        backgroundColor: '#E4E9F2',
      },
      '@media (max-width: 600px)': {
        width: '100%',
      },
    },
  },
  text_style_saveConti: {
    marginLeft: '10px',
    color: '#000000',
    font: 'normal 400 16px/normal Arial',
  },
  disabled_button: {
    '&.MuiButton-root.Mui-disabled': {
      background: `#F3F3F3`,
      border: `#F3F3F3`,
      borderRadius: '25px',
      color: '#D0D0D0',
      width: '165px',
      height: '45px',
      font: 'normal normal bold 16px/18px Arial',
      letterSpacing: '1.01px',
      textTransform: 'none',
      '&:hover': {
        backgroundColor: '#F3F3F3',
      },
      '@media (max-width: 600px)': {
        width: '100%',
      },
    },
  },
  disabled_button_bundle: {
    '&.MuiButton-root.Mui-disabled': {
      background: theme?.palette?.disabledButtonBackground?.main,
      borderRadius: '56px',
      color: theme?.palette?.disabledButton?.main,
      border: 'none',
      width: '100% !important',
      height: '48px !important',
      font: 'normal normal 700 16px/20px Arial',
      letterSpacing: '0px',
      textTransform: 'none',
      '&:hover': {
        backgroundColor: theme?.palette?.disabledButtonBackground?.main,
      },
      '@media (max-width: 600px)': {
        width: '100%',
      },
    },
  },
  allbuttonsBox: {
    borderRadius: '100px',
    background: '#F4EDF4',
    display: 'inline-flex',
    padding: '12px 30px',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '10px',
    color: '#661C69',
    textAlign: 'center',
    fontSize: '16px',
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: '20px',
    height: '48px',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#F4EDF4',
    },
    '@media (max-width: 600px)': {
      width: '100%',
    },
  },
  contact_container: {
    padding: '10px 35px 10px 10px',
    background: `${COLOR3} 0% 0% no-repeat padding-box`,
    border: `0.25px solid ${GRAY44}`,
    borderRadius: '10px',
    opacity: 1,
    marginBottom: '20px',
    '@media (max-width: 960px)': {
      padding: '20px 25px',
    },
  },
  first_screen_img: {
    '@media (max-width: 960px)': {
      display: 'flex',
      justifyContent: 'center',
      maxWidth: 'none',
      marginTop: 0,
    },
    '@media (max-width: 650px)': {
      display: 'flex',
      justifyContent: 'center',
    },
  },
  personalWrapper: {
    padding: '45px 35px',
    '@media (max-width: 960px)': {
      padding: '20px 25px 25px 25px',
    },
  },
  personalPageWrapper: {
    paddingTop: '30px',
    paddingRight: '30px',
    paddingBottom: '30px',
    paddingLeft: '30px',
    '@media (max-width: 599px)': {
      paddingTop: 0,
      paddingRight: 0,
      paddingBottom: 0,
      paddingLeft: 0,
    },
  },
  idDescriptionWrapper: {
    width: '80%',
    margin: '0 0 0 18%',
    '@media (max-width: 960px)': {
      width: '100%',
      margin: '20px auto 0',
    },
    '@media (max-width: 650px)': {
      marginTop: '25px',
      width: '100%',
    },
  },
  idDescriptionOne: {
    font: 'normal normal bold 18px/21px Arial',
    '@media (max-width: 960px)': {
      font: 'normal normal bold 16px/17px Arial',
    },
  },
  IEPersonal_heading_info: {
    marginTop: 0,
    marginBottom: '25px',
    font: 'normal normal bold 20px/23px Arial',
    '@media (max-width: 650px)': {
      marginTop: 0,
      marginBottom: '25px',
    },
  },
  ContinueBtnGrid: {
    '@media (max-width: 600px)': {
      order: '1',
    },
  },
  backBtnGrid: {
    '@media (max-width: 600px)': {
      order: '2',
    },
  },
  disabled_button_otp: {
    '&.MuiButton-root.Mui-disabled': {
      background: `#F3F3F3`,
      border: `#F3F3F3`,
      borderRadius: '56px',
      color: '#D0D0D0',
      width: '184px',
      height: '45px',
      font: 'normal normal bold 16px/18px Arial',
      letterSpacing: '1.01px',
      textTransform: 'none',
      '&:hover': {
        backgroundColor: '#F3F3F3',
      },
      '@media (max-width: 600px)': {
        width: '100%',
      },
    },
  },
  mobileButtons: {
    '@media (max-width: 600px)': {
      width: '100%',
    },
  },
  label_Text: {
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '18px',
    color: '#444444',
  },
  personal_button_container: {
    marginTop: '10px',
    marginBottom: '30px',
    justifyContent: 'center',
    display: 'flex',
  },
  cancel_next_button_container: {
    marginTop: '30px',
    marginBottom: '30px',
    justifyContent: 'center',
    display: 'flex',
  },
  back_button_otp: {
    border: `1px solid ${RADIO_COLOR}`,
    borderRadius: '56px',
    opacity: 1,
    width: '184px',
    height: '45px',
    margin: '0px 20px 0px 0px',
    font: FONT_BOLD_16_18,
    letterSpacing: '1.01px',
    color: `${RADIO_COLOR} !important`,
    textTransform: 'none',
    '&:hover': {
      backgroundColor: COLOR4,
    },
    '&:focus': {
      outline: `2px solid ${RADIO_COLOR}`,
      outlineOffset: '2px',
    },
    '@media (max-width: 600px)': {
      width: '100%',
      margin: '0px 0px 20px 0px',
    },
  },
  continue_button_otp: {
    border: `1px solid ${RADIO_COLOR}`,
    background: `${RADIO_COLOR} 0% 0% no-repeat padding-box`,
    borderRadius: '56px',
    opacity: 1,
    width: '184px',
    height: '45px',
    font: FONT_BOLD_16_18,
    textTransform: 'none',
    color: COLOR4,
    '&:hover': {
      backgroundColor: RADIO_COLOR,
    },
    '&:focus': {
      outline: `2px solid ${RADIO_COLOR}`,
      outlineOffset: '2px',
    },
    '@media (max-width: 600px)': {
      width: '100%',
    },
    '&.Mui-disabled span': {
      opacity: 0.6,
    },
  },
  saveApplicationBundle: {
    width: 248,
    height: 48,
    paddingTop: '12px',
    paddingRight: '24px',
    paddingBottom: '12px',
    paddingLeft: '24px',
    gap: '10px',
    color: '#661C69',
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: '16px',
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: '20px',
    opacity: 1,
    borderRadius: '56px',
    border: '1.6px solid #661C69',
    backgroundColor: '#FFFFFF',
    textTransform: 'none',
    '@media (max-width: 600px)': {
      width: '100%',
    },
    '&:focus': {
      outline: `2px solid ${RADIO_COLOR}`,
      outlineOffset: '2px',
    },
  },
  saveApplicationButton: {
    borderRadius: '100px',
    background: '#F4EDF4',
    display: 'inline-flex',
    padding: '12px 30px',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '10px',
    color: '#661C69',
    textAlign: 'center',
    fontSize: '16px',
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: '20px',
    height: '48px',
    textTransform: 'none',
    '@media (max-width: 600px)': {
      width: '100%',
    },
    '&:focus': {
      outline: `2px solid ${RADIO_COLOR}`,
      outlineOffset: '2px',
    },
  },
  mobileSaveApplicationButtonBundle: {
    padding: '0px',
    minWidth: '48px',
    '&:hover': {
      backgroundColor: 'inherit !important',
    },
  },
  saveApplicationButtonBundle1: {
    height: '46px !important',
    width: '48px !important',
    borderRadius: '56px',
    border: `1.6px solid ${theme?.palette?.orientalPrimary?.main}`,
    color: theme?.palette?.orientalPrimary?.main,
    display: 'inline-flex',
    padding: '12px',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    '&:focus': {
      outline: `2px solid ${theme?.palette?.orientalPrimary?.main}`,
      outlineOffset: '2px',
    },
    '&:hover': {
      backgroundColor: 'inherit !important',
    },
  },
  saveApplicationButtonBundle: {
    minWidth: '248px !important',
    borderRadius: '56px',
    border: `1.6px solid ${theme?.palette?.orientalPrimary?.main}`,
    color: theme?.palette?.orientalPrimary?.main,
    display: 'inline-flex',
    padding: '12px 24px',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '10px',
    textAlign: 'center',
    fontSize: '16px',
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: '20px',
    height: '48px',
    letterSpacing: '0px',
    textTransform: 'none',
    '&:focus': {
      outline: `2px solid ${theme?.palette?.orientalPrimary?.main}`,
      outlineOffset: '2px',
    },
    '&:hover': {
      backgroundColor: 'inherit !important',
    },
  },
  saveApplicationButtonDIS: {
    '&.MuiButton-root.Mui-disabled': {
      borderRadius: '100px',
      background: `#F3F3F3`,
      border: `#F3F3F3`,
      display: 'inline-flex',
      padding: '12px 30px',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '10px',
      color: 'rgba(143, 155, 179, 0.5)',
      textAlign: 'center',
      fontSize: '16px',
      fontFamily: 'Arial',
      fontStyle: 'normal',
      fontWeight: '700',
      lineHeight: '20px',
      // width: '260px',
      height: '48px',
      textTransform: 'none',
    },
    '@media (max-width: 600px)': {
      width: '100%',
    },
  },
  next_continue_button: {
    border: `1px solid ${theme?.palette?.orientalPrimary?.main}`,
    background: `${theme?.palette?.orientalPrimary?.main} 0% 0% no-repeat padding-box`,
    color: theme?.palette?.secondary?.main,
    borderRadius: '25px',
    opacity: 1,
    width: '242px',
    height: '48px',
    font: FONT_BOLD_16_18,
    fontWeight: 700,
    textTransform: 'none',
    '&:hover': {
      backgroundColor: theme?.palette?.orientalPrimary?.main,
    },
    '&:focus': {
      outline: `2px solid ${theme?.palette?.orientalPrimary?.main}`,
      outlineOffset: '2px',
    },
    '@media (max-width: 600px)': {
      width: '100%',
      // marginBottom: '20px',
    },
    '&.Mui-disabled span': {
      opacity: 0.6,
    },
  },
  next_disabled_button: {
    '&.MuiButton-root.Mui-disabled': {
      background: `#E4E9F2`,
      border: `#E4E9F2`,
      borderRadius: '25px',
      fontWeight: 700,
      color: 'rgba(143, 155, 179, 0.5)',
      width: '242px',
      height: '48px',
      font: 'normal normal bold 16px/18px Arial',
      letterSpacing: '1.01px',
      textTransform: 'none',
      '&:hover': {
        backgroundColor: '#E4E9F2',
      },
    },
    '@media (max-width: 600px)': {
      width: '100%',
    },
  },
  error_message_product: {
    font: 'normal normal normal 14px/16px Arial',
    letterSpacing: '0.1px',
    color: COLOR2,
    opacity: 1,
    marginTop: '4px',
    display: 'block',
  },
  optionalStyles: {
    font: '400 10px Arial',
    color: '#727578',
  },
  webHeaderStyle: {
    marginLeft: '-36px',
    '@media (max-width:600px)': { marginLeft: '-14px' },
  },
});
